import { useTypesStore } from "../store/Types.js";
import { useTypesRender } from "../utils/useRender.js";
export var Undefined = props => {
  var {
    Undefined: Comp = {}
  } = useTypesStore();
  useTypesRender(Comp, props, 'Undefined');
  return null;
};
Undefined.displayName = 'JVR.Undefined';